import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import { addSizeToDataLayer } from "@/functions/analytics";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";

import {Props} from "@/components/ShapeType.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CircleDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix } = __props;

const dimensions = computed(() => store.getters.getMeasurements( 'circle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

document.addEventListener('focusin', (event) => store.commit('updateFocusedElement', event));
document.addEventListener('focusout', () => store.commit('updateFocusedElement', ''));

onBeforeUnmount(() => {
	document.removeEventListener('focusout', () => store.commit('updateFocusedElement'));
	document.removeEventListener('focusin', () => store.commit('updateFocusedElement'));
});

const diameter = computed({
	get: () => dimensions.value.diameter,
	set: (value: string) => {
		store.dispatch( action, {
			dimension: "diameter",
			value: value,
		});
	},
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "circle-diameter",
        id: `${_ctx.prefix}measurements-circle-diameter`,
        name: `${_ctx.prefix}measurements[dimensions][diameter]`,
        unit: "cm",
        label: dimensionLabel.value('diameter', 'circle'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('diameter'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}circle-diameter`),
        onBlur: () => _unref(addSizeToDataLayer)('diameter', +diameter.value, 'circle'),
        modelValue: diameter.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((diameter).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"])
    ]),
    _: 1
  }))
}
}

})